var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.convenio.idSituacaoConvenio != 9)?_c('span',{staticClass:"text-succesx float-left mr-1"},[_c('i',{staticClass:"fa fa-times fa-lg icon-button",attrs:{"title":"Glosar Prestação"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarGlosar()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }